import { Box, Typography, KeyboardArrowRightIcon } from 'src/components';
import { format } from 'date-fns';
import { useNavigate } from 'react-router-dom';

import placeholderImage from 'src/assets/placeholders/140x140.png';

export default function UserTripsList({ trips = [], userId }) {
    const navigate = useNavigate();

    if (!Array.isArray(trips) || trips.length === 0) {
        return (
            <Typography variant="body2" color="text.secondary">
                No trips logged yet.
            </Typography>
        );
    }

    const navigateToTrip = (tripId, polarstepsUrl) => {
        if (polarstepsUrl) {
            window.open(polarstepsUrl, '_blank');
            return;
        }
        navigate(`/trips/${tripId}/${userId}`);
    };

    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
            {trips.map((trip) => (
                <Box
                    key={trip.id}
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        p: 1,
                        height: 125,
                        borderRadius: 1,
                        border: '1px solid #ddd',
                        cursor: 'pointer',
                        '&:hover': {
                            backgroundColor: '#f9f9f9',
                        },
                    }}
                    onClick={() => navigateToTrip(trip.id, trip.polarstepsUrl)}
                >
                    <Box
                        component="img"
                        src={trip.coverImageUrl || placeholderImage}
                        alt={trip.name}
                        sx={{
                            width: 125,
                            height: '100%',
                            objectFit: 'cover',
                            borderRadius: 1,
                            mr: 1.5,
                        }}
                    />

                    <Box sx={{
                        height: '100%', 
                        width: '100%', 
                        display: 'flex', 
                        justifyContent: 'space-between', 
                        alignItems: 'center'}}>

                        <Box sx={{ 
                            py: 1, 
                            height: '100%', 
                            display: 'flex', 
                            justifyContent: 'center',
                            flexDirection:' column', 
                            position: 'relative' }}>

                            <Typography variant="body2" color="text.secondary" noWrap 
                                sx={{position: 'absolute', top: 4}}>
                                {format(new Date(trip.startDate), 'MMM dd, yyyy')}
                            </Typography>
                            <Typography variant="h5" fontWeight="bold" wrap>
                                {trip.name}
                            </Typography>
                        </Box>

                        <KeyboardArrowRightIcon />
                    </Box>
                </Box>
            ))}
        </Box>
    );
}
